"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _qrious = _interopRequireDefault(require("qrious"));

var _jsxFileName = "E:\\720\\720yun_player\\packages\\pano-qrcode\\src\\QRCode.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var QRCode = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(QRCode, _React$PureComponent);

  function QRCode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      img: null
    });

    _defineProperty(_assertThisInitialized(_this), "generate", function () {
      _this.setValue();

      _this.loadImage();
    });

    _defineProperty(_assertThisInitialized(_this), "setValue", function () {
      var _this$props = _this.props,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 800 : _this$props$size,
          url = _this$props.url;

      _this.qr.set({
        level: "H",
        size: size,
        value: url
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onLoadImage", function (img) {
      var _this$props$size2 = _this.props.size,
          size = _this$props$size2 === void 0 ? 800 : _this$props$size2;
      var imgSize = size / 3.5;
      var x = parseFloat((size - imgSize) / 2);
      _this.ctx.fillStyle = "#ffffff";

      _this.ctx.fillRect(x, x, imgSize, imgSize);

      _this.ctx.drawImage(img, x, x, imgSize, imgSize);

      _this.generateImage();
    });

    _defineProperty(_assertThisInitialized(_this), "loadImage", function () {
      var centreImg = _this.props.centreImg;
      var img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = function () {
        _this.onLoadImage(img);
      };

      img.onerror = function () {
        _this.generateImage();
      };

      img.src = centreImg;
    });

    _defineProperty(_assertThisInitialized(_this), "generateImage", function () {
      var img = _this.canvas.toDataURL("image/png");

      _this.setState({
        img: img
      });
    });

    return _this;
  }

  var _proto = QRCode.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.qr = new _qrious["default"]();
    this.canvas = this.qr.canvas;
    this.ctx = this.canvas.getContext("2d");
    this.generate();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props2 = this.props,
        url = _this$props2.url,
        centreImg = _this$props2.centreImg;
    var prevUrl = prevProps.url,
        prevCentreImg = prevProps.centreImg;

    if (url !== prevUrl || centreImg !== prevCentreImg) {
      this.generate();
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        url = _this$props3.url,
        centreImg = _this$props3.centreImg,
        size = _this$props3.size,
        other = _objectWithoutPropertiesLoose(_this$props3, ["url", "centreImg", "size"]);

    var img = this.state.img;
    return /*#__PURE__*/_react["default"].createElement("img", _extends({
      src: img
    }, other, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 12
      }
    }));
  };

  return QRCode;
}(_react["default"].PureComponent);

var _default = QRCode;
exports["default"] = _default;
module.exports = exports.default;